import { render, staticRenderFns } from "./VBreadcrumbs.vue?vue&type=template&id=4cd099a8"
import script from "./VBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./VBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./VBreadcrumbs.vue?vue&type=style&index=0&id=4cd099a8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd099a8')) {
      api.createRecord('4cd099a8', component.options)
    } else {
      api.reload('4cd099a8', component.options)
    }
    module.hot.accept("./VBreadcrumbs.vue?vue&type=template&id=4cd099a8", function () {
      api.rerender('4cd099a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VBreadcrumbs.vue"
export default component.exports